module.exports = __webpack_public_path__ + "static/media/Sudan.516c7d9e.png";